import React from 'react';
import PropTypes from 'prop-types';

const UrgencySelect = ({urgencies, value, onChange = () => {}}) => (
    <div className="order-form__item order-form__item__urgency">
        <div className="order-form__label">Urgency</div>
        <div id="urgencies-list-wrap" className="order-form__value">
            <select id="urgency" name="urgency" value={value} onChange={(event) => {onChange(event.target.value)}}>
                {urgencies.map(urgency => (
                    <option key={urgency.id} value={urgency.id}>{urgency.name}</option>
                ))}
            </select>
        </div>
    </div>
)

UrgencySelect.propTypes = {
    urgencies: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
    })).isRequired,
    value: PropTypes.number,
    onChange: PropTypes.func,
};

export default UrgencySelect;